/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 13:49:53
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-25 10:48:12
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/ProductInfo/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { useSelector } from 'react-redux';
import { Rate } from 'src/components/Antd';
import ImageDisplay, { Type } from 'src/components/Upload/ImageDisplay';
import { useI18n } from 'src/hooks/useRouterChange';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { getProductInfo } from '../slice';

const ProductInfo = () => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const data = useSelector(getProductInfo());
  const { ave, pendingAmount, publishedAmount, product, totalAmount } =
    data || {};
  const { sku, name, thumbnailUrl } = product || {};
  return (
    <Element>
      <SectionWrapper
        title={getI18n(
          'reviews.productreview.productReviewDetail_productInfo_genaral_product_details',
        )}>
        <Row
          elements={[
            {
              child: (
                <ProductPart
                  sku={sku}
                  name={name}
                  thumbnailUrl={thumbnailUrl}
                />
              ),
            },
            {
              child: (
                <ReviewPart
                  totalAmount={totalAmount}
                  publishedAmount={publishedAmount}
                  ave={ave}
                  pendingAmount={pendingAmount}
                />
              ),
            },
          ]}
        />
      </SectionWrapper>
    </Element>
  );
};
export default ProductInfo;

const ProductPart = ({ sku, name, thumbnailUrl }) => {
  return (
    <div className={css.productContainer}>
      <div className={css.productName}>{name}</div>
      <div className={css.productSku}>{sku}</div>
      <div className={css.productImg}>
        <ImageDisplay
          imageUrl={thumbnailUrl}
          type={Type.Fill}
          height={180}
          //fileList={[]}
          hideAction
        />
      </div>
    </div>
  );
};

const ReviewPart = ({ ave, totalAmount, publishedAmount, pendingAmount }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <div className={css.productContainer}>
      <div className={css.ratingContainer}>
        <ItemWrapper
          title={getI18n(
            'reviews.productreview.productReviewDetail_productInfo_genaral_ReviewPart_rating_title',
          )}
          bottomTitle={replaceI18nVariables(
            getI18n('reviews.productreview.productReviewDetail_Amount_Reviews'),
            totalAmount,
          )}>
          <Rate
            disabled={true}
            hasText
            customText={replaceI18nVariables(
              getI18n(
                'reviews.productreview.productReviewDetail_productInfo_genaral_ReviewPart_customText',
              ),
              ave,
            )}
            value={ave}
          />
        </ItemWrapper>
        <ItemWrapper
          title={getI18n(
            'reviews.productreview.productReviewDetail_productInfo_genaral_ReviewPart_published_title',
          )}
          bottomTitle={replaceI18nVariables(
            getI18n('reviews.productreview.productReviewDetail_Amount_Reviews'),
            publishedAmount,
          )}
        />
        <ItemWrapper
          title={getI18n(
            'reviews.productreview.productReviewDetail_productInfo_genaral_ReviewPart_Pending_bottomTitle',
          )}
          bottomTitle={replaceI18nVariables(
            getI18n('reviews.productreview.productReviewDetail_Amount_Reviews'),
            pendingAmount,
          )}
        />
      </div>
    </div>
  );
};
